import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const useGetResetPasswordParams = () => {
  const location = useLocation();
  // eslint-disable-next-line
  const params = new URLSearchParams(location.search);
  const [isLoading, setIsLoading] = useState(true);
  const [username, setUsername] = useState<string | null>(null);

  useEffect(() => {
    setIsLoading(true);
    setUsername(params.get("username") ? decodeURI(params.get("username")!): '');
    setIsLoading(false);
    // eslint-disable-next-line
  }, [params, location, location.search]);

  return {
    username,
    isLoading,
  };
};

export default useGetResetPasswordParams;
